import { createSlice } from "@reduxjs/toolkit";
import { fetchNurseServicesReducer } from "../../reducer/services/nurseServicesReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  pagination: { page: 1, limit: 10, total: 0, totalPages: 1 },
  isLoading: false,
  error: null,
};

const nurseServicesSlice = createSlice({
  name: "nurseServices",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNurseServicesReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchNurseServicesReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.services || [];
        state.pagination = {
          page: action.payload?.pagination?.page || 1,
          limit: action.payload?.pagination?.limit || 10,
          total: action.payload?.pagination?.total || 0,
          totalPages:
            action.payload?.pagination?.totalPages ||
            action.payload?.pagination?.total_pages ||
            1,
        };
      })
      .addCase(fetchNurseServicesReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadServices");
      });
  },
});

export default nurseServicesSlice.reducer;
